import type { ProjectMilestone } from "@/types/domain";

/** Phase 1 时间线（2026-09 → 2027-01） */
export const PROJECT_TIMELINE: ProjectMilestone[] = [
  { id: "sep", month: "2026-09" },
  { id: "oct", month: "2026-10" },
  { id: "nov", month: "2026-11" },
  { id: "dec", month: "2026-12" },
  { id: "jan", month: "2027-01" },
];

/** 公开事实：不含具体金额 */
export const PROJECT_FACTS = {
  plannedStart: "2026-09-01",
  plannedEnd: "2026-12-31",
  finalReportDue: "2027-01-31",
  phaseOneScope: "controlled-still-water",
  coreIndicators: 5,
  teams: 4,
} as const;
